<template>
    <SelectSearchInput
        :list="localTimezoneList"
        :value="value"
        :name="name"
        :disabled="disabled"
        :useBookingFormThemeCssVariables="useBookingFormThemeCssVariables"
        :required="required"
        @onSelectionChange="
            emit('onTimezoneSelectionChange', { value: $event.value })
        "
    />
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import { TimeZoneEnumList } from '@/Shared/AutoGenerated/TimeZoneEnum'
    import type { SearcheableEntity } from '@/Shared/Component/Forms/SelectSearchInput.vue'
    import SelectSearchInput from '@/Shared/Component/Forms/SelectSearchInput.vue'

    const emit = defineEmits<{
        onTimezoneSelectionChange: [{ value: string }]
    }>()

    const props = defineProps({
        name: {
            type: String,
            default: null,
        },
        value: {
            type: String,
            default: null,
        },
        useBookingFormThemeCssVariables: {
            type: Boolean,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            required: true,
        },
    })

    const timezoneList = TimeZoneEnumList.map((item): SearcheableEntity => {
        return {
            id: item.key.toLowerCase(),
            value: item.key,
            displayText: item.label,
        }
    })
    const localTimezoneList = ref<SearcheableEntity[]>(timezoneList)
</script>
